import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const CancelToken = axios.CancelToken;
let cancel;

export const apiCallPost = async (accessToken, path, datum) => {
  if (!accessToken) {
    throw new Error("Access Token not found");
  }
  const resp = await axios.post(apiUrl + path, datum, {
    credentials: "include",
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return resp.data;
};

export const apiCallPostProgress = async (
  accessToken,
  path,
  datum,
  callback
) => {
  if (!accessToken) {
    throw new Error("Access Token not found");
  }

  const resp = await axios.post(apiUrl + path, datum, {
    credentials: "include",
    headers: {
      "content-type": "multipart/form-data",
      Authorization: accessToken,
    },
    onUploadProgress: (progressEvent) =>
      callback(progressEvent.loaded, progressEvent.total),
  });
  return resp.data;
};

export const apiCallPostCancellable = async (accessToken, path, datum) => {
  if (cancel !== undefined) {
    cancel();
  }
  try {
    if (!accessToken) {
      throw new Error("Access Token not found");
    }
    const res = await axios.post(apiUrl + path, datum, {
      credentials: "include",
      headers: { Authorization: accessToken },
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    });
    return res.data;
  } catch (err) {
    if (axios.isCancel(err)) {
    } else return err;
  }
};

export const isBelow40 = (input) => {
  const targetDate = new Date("2023-12-31");
  let dob = new Date(input);
  // Calculate the age as of December 31, 2023
  let age = targetDate.getFullYear() - dob.getFullYear();
  const m = targetDate.getMonth() - dob.getMonth();

  // Adjust age if the birthday hasn't occurred yet within the current year
  if (m < 0 || (m === 0 && targetDate.getDate() < dob.getDate())) {
    age--;
  }

  // Return true if age is below 40, false otherwise
  return age < 40;
};

export const indianRupee = (amountPaise, fractionDigits, inPaise = true) => {
  let amount = amountPaise;
  if (inPaise) {
    amount = Math.ceil(amountPaise / 100);
  } else {
    amount = parseInt(amountPaise);
  }

  return amount.toLocaleString("en-IN", {
    maximumFractionDigits: fractionDigits,
    style: "currency",
    currency: "INR",
  });
};

export const niceDate = (date) => {
  return new Date(date).toLocaleDateString("en-IN", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const niceTime = (date) => {
  return new Date(date).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const niceDateTime = (date) => {
  return new Date(date).toLocaleTimeString("en-IN", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
export const formattedCurrentTimeForFC = () => {
  const now = new Date();

  const hours = now.getHours().toString().padStart(2, "0");
  const minutes = now.getMinutes().toString().padStart(2, "0");
  const seconds = now.getSeconds().toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};
